import { action, payload } from 'ts-action';

export interface IInsertImagesPayload {
    name: 'INSERT_IMAGES';
    data: {
        images: string;
    };
}

export const IMAGES = 'IMAGES';
export const CLEAR_IMAGES = 'CLEAR_IMAGES';

export const fetchImages = action(IMAGES, payload<{ images: string }>());
export const clearImages = action(CLEAR_IMAGES);

export type ImagesActionType =
    | ReturnType<typeof fetchImages>
    | ReturnType<typeof clearImages>;

const ImagesActionAPI = {
    clearImages,
};

export default ImagesActionAPI;
